module.exports = __webpack_public_path__ + "static/media/marker_blue.567b5477.svg";